import i18n from 'i18next';
import moment from 'moment';

import { SET_LOCALE } from '../actions/i18n';
import { FR } from '../helpers/i18n';

const initialState: string = FR;

export const locale = (
  state = initialState,
  action: Record<string, string>
): string => {
  switch (action.type) {
    case SET_LOCALE:
      i18n.changeLanguage(action.payload);
      moment.locale(action.payload);
      return action.payload;
    default:
      return state;
  }
};

export default locale;
